/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IlvlThresholdDto
 */
export interface IlvlThresholdDto {
    /**
     * Minimum item level for this color.
     * @type {number}
     * @memberof IlvlThresholdDto
     */
    ilvl: number;
    /**
     * Hex color, e.g. #a335ee.
     * @type {string}
     * @memberof IlvlThresholdDto
     */
    color: string;
    /**
     * Item rarity this color belongs to, e.g. Epic.
     * @type {string}
     * @memberof IlvlThresholdDto
     */
    rarity: string;
}

export function IlvlThresholdDtoFromJSON(json: any): IlvlThresholdDto {
    return IlvlThresholdDtoFromJSONTyped(json, false);
}

export function IlvlThresholdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IlvlThresholdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ilvl': json['ilvl'],
        'color': json['color'],
        'rarity': json['rarity'],
    };
}

export function IlvlThresholdDtoToJSON(value?: IlvlThresholdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ilvl': value.ilvl,
        'color': value.color,
        'rarity': value.rarity,
    };
}


